import axios from 'axios';
import uuid from 'react-uuid';

import {
  generateApiHeader,
  DEVICE_FINGERPRINT,
} from '../../../../../utils/api';

export const getAnonyChannel = (
  core,
  updateCore,
  PSITE_SAVINGS_INTEREST_API,
) => {
  const anonyChannelHeader = generateApiHeader();
  axios
    .get(
      `${process.env.CORE_API_URL}/configuration/client-info/app-type/channel-anonymous-one-app`,
      {
        headers: { ...anonyChannelHeader },
        withCredentials: true,
      },
    )
    .then(configResp => {
      // * Check response status
      if (configResp.status !== 200) {
        console.warn(
          `Looks like there was a problem. Status Code: ${configResp.status}`,
        );
        return;
      }
      const clientToken = {
        client_id: configResp.data.clientId,
        client_secret: configResp.data.clientSecret,
        scope: configResp.data.scope,
      };
      getAnonyLogin(clientToken, core, updateCore, PSITE_SAVINGS_INTEREST_API);
    })
    .catch(err => {
      console.warn('Looks like there was a problem. Status Code: ', err);
    });
};

export const getAnonyLogin = (
  clientToken,
  core,
  updateCore,
  PSITE_SAVINGS_INTEREST_API,
) => {
  const anonyLoginHeader = generateApiHeader();
  axios
    .post(
      `${process.env.CORE_API_URL}/iam/login/anonymous`,
      {
        deviceFingerprint: DEVICE_FINGERPRINT,
        authentication: {
          ...clientToken,
          nonce: uuid(),
        },
      },
      {
        headers: { ...anonyLoginHeader },
        withCredentials: true,
      },
    )
    .then(anonyResp => {
      // * Check response status
      if (anonyResp.status !== 200) {
        console.warn(
          `Looks like there was a problem. Status Code: ${anonyResp.status}`,
        );
        return;
      }
      const combinedResp = {
        ...core,
        ...clientToken,
        ...anonyResp.data,
        ...{
          'x-pcf-csrf-token': anonyResp.headers.get('x-pcf-csrf-token'),
        },
      };
      updateCore(combinedResp);
      if (PSITE_SAVINGS_INTEREST_API) {
        getInterestRate(combinedResp, core, updateCore);
      }
    })
    .catch(err => {
      console.warn('Looks like there was a problem. Status Code: ', err);
    });
};

export const getInterestRate = (resp, core, updateCore) => {
  const interestHeader = generateApiHeader();
  axios
    .get(`${process.env.CORE_API_URL}/applications/products/savings/interest`, {
      headers: {
        ...interestHeader,
        ...{
          'x-pcf-csrf-token': resp['x-pcf-csrf-token'],
        },
        ...{
          Authorization: `Bearer ${resp.channel_token}`,
        },
      },
      withCredentials: true,
    })
    .then(interestResp => {
      // * Check response status
      if (interestResp.status !== 200) {
        console.warn(
          `Looks like there was a problem. Status Code: ${interestResp.status}`,
        );
      }
      updateCore({
        rates: {
          ...core.rates,
          ...interestResp.data,
        },
      });
    })
    .catch(err => {
      console.warn('Looks like there was a problem. Status Code: ', err);
    });
};
